import { GAS_INSTALLATION } from '@spa/shared/constants/billTypes';

/**
 * Calculates the total amount of bills that are included and capped
 * @param {Object} bills - Object containing bill information
 * @returns {number} - Total amount of included and capped bills
 */
export const calculateTotalBills = bills => {
  if (!bills) {
    return 0;
  }

  const billNames = Object.keys(bills).filter(key => key !== '__typename' && key !== 'maximum');

  return billNames.reduce((total, billName) => {
    const bill = bills[billName];
    if (bill.included && bill.maximum?.capped && bill.maximum?.max?.amount) {
      return total + bill.maximum.max.amount;
    }

    return total;
  }, 0);
};

export const getBillNames = (accommodationOffer, property) => {
  const offer = accommodationOffer;
  const bills = offer?.costs?.bills;

  const hasGasInProperty = property?.main_features?.gas_type === GAS_INSTALLATION;
  const filterKeys = ['__typename', 'maximum', 'gas'];
  const billNames = [
    ...(bills ? Object.keys(bills).filter(key => !filterKeys.includes(key)) : []),
    ...(hasGasInProperty ? ['gas'] : [])
  ];

  return billNames;
};
